// Compact per-status count strip for the top of the admin participation page.
// Each status renders as a clickable chip (colored dot + label + count) that
// toggles a filter on the table below, plus a total. Reads counts from the
// slice; the active filter is owned by the page so the table and strip stay in
// sync.
import { Box, Chip, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  PARTICIPATION_STATUS_ORDER,
  PARTICIPATION_STATUS_LABELS,
} from '../../../config/participation.js';

const StatusDot = ({ status }) => {
  const theme = useTheme();
  return (
    <Box
      component="span"
      aria-hidden="true"
      sx={{
        width: 12,
        height: 12,
        borderRadius: '50%',
        bgcolor: theme.participationColors[status],
        border: `1px solid ${theme.mapColors.landStroke}`,
      }}
    />
  );
};

const ParticipationStatsStrip = ({ counts, activeFilter, onToggleFilter }) => {
  const total = PARTICIPATION_STATUS_ORDER.reduce((sum, s) => sum + (counts[s] ?? 0), 0);
  return (
    <Box sx={{
      display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1,
    }}
    >
      {PARTICIPATION_STATUS_ORDER.map((s) => {
        const selected = activeFilter === s;
        return (
          <Chip
            key={s}
            variant={selected ? 'filled' : 'outlined'}
            color={selected ? 'primary' : 'default'}
            onClick={() => onToggleFilter(s)}
            aria-pressed={selected}
            label={(
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                <StatusDot status={s} />
                {`${PARTICIPATION_STATUS_LABELS[s]}: ${counts[s] ?? 0}`}
              </Box>
            )}
          />
        );
      })}
      <Typography variant="body2" color="text.secondary" sx={{ ml: 'auto' }}>
        {`${total} counties`}
      </Typography>
    </Box>
  );
};

export default ParticipationStatsStrip;
